// customer-state custkey
export const OFFER_SUBMITTED_FORM_CUST_KEY = 'SubmittedForm';

// errorCode
export const PROMOTION_ERROR_CODE = [
  'XPAPI:MANDATORY_PROMOCODE_NOTVALID',
  'XPAPI:OPTIONAL_PROMOCODE_NOTVALID',
];
